/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecuteResolveRecommendationsRequest {
    getFixupPrototypeFunction() { return ExecuteResolveRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ExecuteResolveRecommendationsRequest>): ExecuteResolveRecommendationsRequest {
        let obj = Object.assign(new ExecuteResolveRecommendationsRequest(), model);
        ExecuteResolveRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecuteResolveRecommendationsRequest>): ExecuteResolveRecommendationsRequest {
        if (!model) return null;
        return ExecuteResolveRecommendationsRequest.newInstance(<ExecuteResolveRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecuteResolveRecommendationsRequest) {
        if (!obj) return;

        models.ExecuteResolveRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecuteResolveRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ExecuteResolveRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action Name to resolve the recommendation
     */
    action_name: string;

    /**
     * Resource ID
     */
    resources: Array<string>;

    /**
     * Apply for all the resources.Allowed Values true or false
     */
    apply_for_all: boolean;

}
